import React from "react";
import HrQTrainingTable from "../../components/Dashboard/Tables/HrQTrainingTable";
import { MenuItem, Select } from "@mui/material";

function HrQTraining() {
  const [status, setStatus] = React.useState("showAll");

  const handleChange = (event) => {
    setStatus(event.target.value);
  };

  const menuItemStyle = {
    fontFamily: 'Inter',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#292727',
    ":hover":{
       background:'#EDF5FF'
    },
    ":active":{
      background:'#FFFFFF'
   },
  }

  return (
    <div>
      <div className="flex justify-end gap-4 flex-col md:flex-row  bg-white p-4">
        <div className="flex gap-4 items-center ">
          <p className=" font-medium font-sans leading-normal text-[10px] not-italic text-[#98A2B3] ml-2 lg:ml-0">Filter by:</p>
          <Select 
            value={status} 
            onChange={handleChange} 
            className="w-[190px] h-12 py-3 px-4"
            sx={{
              '& .MuiOutlinedInput-notchedOutline':{
              border: '1px solid #DEDEDE'
              },
              '& .MuiSelect-select':{
                fontFamily: 'Inter',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px',
                color:'#425466'
              }
              }}
            >
            <MenuItem sx={menuItemStyle} value={"showAll"}>Show All</MenuItem>
            <MenuItem sx={menuItemStyle} value={"active"}>Active</MenuItem>
            <MenuItem sx={menuItemStyle} value={"inactive"}>Inactive</MenuItem>
          </Select>
        </div>
      </div>
      <HrQTrainingTable />
    </div>
  );
}

export default HrQTraining;
